import { FC } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const FirstEmpty: FC<Props> = ({ width = '38', height = '48' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 48" fill="none">
      <path
        d="M25.7336 18.5029C21.6704 11.4652 13.5638 8.20152 6.03117 9.97306C3.61194 10.542 1.18961 9.0423 0.620571 6.6231C0.0515926 4.20387 1.55132 1.78154 3.97052 1.2125C15.2609 -1.44287 27.4246 3.43186 33.5278 14.0029C39.631 24.574 37.7708 37.5454 29.826 45.9955C28.1236 47.8061 25.2759 47.8937 23.4653 46.1913C21.6547 44.4889 21.5671 41.6413 23.2695 39.8306C28.57 34.193 29.7968 25.5406 25.7336 18.5029Z"
        fill="#D9CCB9"
      />
      <path
        d="M33.0947 14.2529C27.1049 3.87835 15.1663 -0.907141 4.08455 1.69918C1.93441 2.20517 0.601448 4.35871 1.10718 6.50902C1.61313 8.6592 3.76669 9.99212 5.91702 9.48639C13.6586 7.66585 21.9902 11.0193 26.1665 18.2529C30.3429 25.4866 29.0812 34.3787 23.6338 40.1728C22.1207 41.7821 22.1983 44.3136 23.8074 45.8269C25.4167 47.34 27.9482 47.2624 29.4615 45.6534C37.2595 37.3594 39.0845 24.6275 33.0947 14.2529ZM33.9608 13.7529C40.1773 24.5203 38.2817 37.7315 30.1904 46.3376C28.2989 48.3493 25.1349 48.447 23.1231 46.5558C21.1114 44.6643 21.0137 41.5003 22.905 39.4885C28.0584 34.0073 29.2505 25.5946 25.3005 18.7529C21.3505 11.9113 13.4688 8.73736 6.1452 10.4597C3.45732 11.0917 0.766073 9.42508 0.133833 6.7372C-0.498118 4.0493 1.16847 1.35807 3.85637 0.725833C15.3552 -1.97844 27.7442 2.98551 33.9608 13.7529Z"
        fill="#F7F3F0"
      />
    </svg>
  );
};

export default FirstEmpty;
